import BigNumber from "bignumber.js";
import { sleep } from "@/utils";
import pLimit from "p-limit";
import erc20 from "@/abi/erc20.json";
import { SuiClient } from "@mysten/sui/client"
import { Contract, formatUnits, Provider, Wallet } from "ethers";
import { DataType } from "../../interface";
import { getNativeTokenInfo } from "@/request/native";
import { isSuiCoinType, isValidCoinType, walletFromSuiPrivkey } from "@/utils/suiMethods";
// Threshold for sufficient gas fee in SOL (e.g., 0.001 SOL)
const GAS_FEE_THRESHOLD = 0.001;
const erc20Abi = erc20.output.abi;
const nativeCoin = getNativeTokenInfo();

export function calculateTotalBalances(data: any[]) {
  let totalSelectedBalance = new BigNumber(0);
  let totalSelectedBalanceWei = new BigNumber(0);
  let totalSelectedTokenBalance = new BigNumber(0);
  let totalSelectedTokenBalanceWei = new BigNumber(0);

  data.forEach((item) => {
    totalSelectedBalance = totalSelectedBalance.plus(item.balance);
    totalSelectedBalanceWei = totalSelectedBalanceWei.plus(item.balanceWei);
    totalSelectedTokenBalance = totalSelectedTokenBalance.plus(
      item.tokenBalance
    );
    totalSelectedTokenBalanceWei = totalSelectedTokenBalanceWei.plus(
      item.tokenBalanceWei
    );
  });

  return {
    totalSelectedBalance: totalSelectedBalance.toString(),
    totalSelectedBalanceWei: totalSelectedBalanceWei.toString(),
    totalSelectedTokenBalance: totalSelectedTokenBalance.toString(),
    totalSelectedTokenBalanceWei: totalSelectedTokenBalanceWei.toString(),
  };
}

export async function generateResults(
  client: SuiClient,
  keypairs: string,
  basicInfo: any, // 选中的代币信息对象
  chunkSize: number = 500,
  coinType: string
) {
  console.log("进来了11")
  console.log("xxxwwwwwww")
  console.log("进来了1122")
  const tempList = keypairs.split("\n");
  const privateKeyList = tempList.filter((item: string) => item !== "");
  const walletList = privateKeyList.map((pk) => walletFromSuiPrivkey(pk));
  console.log("xxx walletListwalletList", walletList)
  const addresses = await Promise.all(
    walletList.map((wallet) => wallet.address)
  );
  console.log("xxx address", addresses)
  console.log("clientclientclientclientclient1", client)
  // // 2. 定义存放结果的数组
  const items = new Array(privateKeyList.length);
  // // 3. 分批处理
  // //    - 每次取 chunkSize 个地址
  for (let i = 0; i < addresses.length; i += chunkSize) {
    // 3.1 截取一批地址、对应的钱包
    const chunkAddresses = addresses.slice(i, i + chunkSize);
    const chunkWallets = walletList.slice(i, i + chunkSize);
    console.log("chunkAddresses", chunkAddresses)
    // 3.2 并发获取本批次所有地址的 Native 币 & erc20币 余额
    const [nativeBalanceList, erc20TokenBalanceList] = await Promise.all([
      Promise.all(chunkAddresses.map((addr) => client.getBalance({
        owner: addr
      }))),
      Promise.all(
        chunkAddresses.map((addr) => {
          if (isValidCoinType(coinType)) {
            return client.getBalance({
              owner: addr,
              coinType
            });
          }
          return Promise.resolve({ totalBalance: BigInt(0) });
        })
      ),
    ]);
    console.log("nativeBalanceList", nativeBalanceList)
    console.log("erc20TokenBalanceList", erc20TokenBalanceList)

    // 3.3 组装本批次的结果到 items
    chunkAddresses.forEach((addr, indexInChunk) => {
      const globalIndex = i + indexInChunk; // 对应在原始列表中的索引
      const balanceWei = nativeBalanceList[indexInChunk].totalBalance;
      const otherTokenBalanceWei = erc20TokenBalanceList[indexInChunk].totalBalance;
      console.log("查询时otherTokenBalanceWei", otherTokenBalanceWei)
      console.log("查询时basicInfo", basicInfo)
      items[globalIndex] = {
        key: globalIndex,
        privateKey: privateKeyList[globalIndex],
        walletAddress: addr,
        balance: formatUnits(balanceWei, 9),
        balanceWei: balanceWei,
        tokenBalance: Object.keys(basicInfo).length > 0
          ? formatUnits(otherTokenBalanceWei, basicInfo.decimals || 9)
          : 0,
        tokenBalanceWei: otherTokenBalanceWei,
        walletInstance: chunkWallets[indexInChunk],
        toAddress: "",
        approvedToken: [],
        successHashs: [],
        failedCount: 0,
        status: 0,
        tx: "",
        msg: "",
      };
    });

    //   // 3.4 更新进度
    //   //     已处理的数量 = i + 当前批次的数量
    // const processedCount = i + chunkAddresses.length;
    // setProgress((processedCount / addresses.length) * 100);
  }
  console.log("items", items)
  // 4. 全部批次处理完毕，更新状态
  return items;
  // return 1
}

export async function updateWalletBalances(
  wallets: DataType[],
  selectedTokenInfo: any,
  provider: Provider
) {
  let tokenContract: Contract;
  const { address: tokenAddress } = selectedTokenInfo;
  if (tokenAddress.startsWith("0x")) {
    tokenContract = new Contract(tokenAddress, erc20Abi, provider);
  }

  try {
    const updatedWallets = await Promise.all(
      wallets.map(async (wallet) => {
        const address = wallet.walletAddress;
        const item: DataType = { ...wallet };

        // 获取钱包地址、原生币余额
        const balanceWei = await provider.getBalance(address);
        item.balance = formatUnits(balanceWei, nativeCoin.decimals);
        item.balanceWei = balanceWei.toString();

        if (tokenAddress.startsWith("0x")) {
          const tokenBalanceWei = await tokenContract?.balanceOf(address);
          item.tokenBalance = formatUnits(
            tokenBalanceWei,
            selectedTokenInfo.decimals || 18
          );
          item.tokenBalanceWei = tokenBalanceWei;
        } else {
          item.tokenBalance = formatUnits(balanceWei, nativeCoin.decimals);
          item.tokenBalanceWei = balanceWei.toString();
        }

        // 每次查询后,更新实际归集数量
        item.opAmount = item.tokenBalance;
        item.opAmountWei = item.tokenBalanceWei;

        return item;
      })
    );

    // setWallets(updatedWallets);
    return updatedWallets;
  } catch (error) {
    console.log("更新代币余额error", error);
    return [];
  }
}
